import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=ee8ac5be&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee8ac5be')) {
      api.createRecord('ee8ac5be', component.options)
    } else {
      api.reload('ee8ac5be', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=ee8ac5be&", function () {
      api.rerender('ee8ac5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21hKcRwY2fGbs/JS/comp/ImgFallback2.vue"
export default component.exports